<mat-accordion multi="true">
    <div *ngFor="let group of this.functionalitygroups">
        <div *ngIf="group?.Features?.length > 0 || group?.Children?.length > 0">
            <mat-expansion-panel class="functionalityGroupContainer remove-mat-expansion-panel-padding">
                <mat-expansion-panel-header>
                    <mat-panel-title
                        ><span>{{ group.Title }}</span></mat-panel-title
                    >
                </mat-expansion-panel-header>
                <div class="contentGlobalFragment" *ngFor="let feature of group.Features">
                    <ms-feature-element
                        [feature]="feature"
                        [featureDataSheet]="getFeatureDataSheetDetail(feature.Fragment)"
                        [industry]="this.currentIndustry"
                        [editionCode]="this.editionSelected"
                        (onfeatureClick)="onfeatureclick($event)"
                    >
                    </ms-feature-element>
                </div>

                <div *ngFor="let groupChild of group.Children">
                    <div *ngIf="groupChild.Features.length > 0">
                        <h3 class="titleGroupFeatures">{{ groupChild.Title }}</h3>

                        <div class="contentGlobalFragment" *ngFor="let feature of groupChild.Features">
                            <ms-feature-element
                                [feature]="feature"
                                [featureDataSheet]="getFeatureDataSheetDetail(feature.Fragment)"
                                [industry]="this.currentIndustry"
                                [editionCode]="this.editionSelected"
                                (onfeatureClick)="onfeatureclick($event)"
                            >
                            </ms-feature-element>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </div>
    </div>

    <div *ngIf="this.currentIndustry?.CountableFeatures?.length > 0">
        <mat-expansion-panel class="functionalityGroupContainer2">
            <mat-expansion-panel-header>
                <mat-panel-title><span translate>INDUSTRY_CONFIGURATOR.SPECIALIZEDUSERS</span></mat-panel-title>
                <mat-panel-description><span translate>INDUSTRY_CONFIGURATOR.SPECIALIZEDUSERSSUBTITLE</span></mat-panel-description>
            </mat-expansion-panel-header>
            <div class="contentGlobalFragment" *ngFor="let feature of this.currentIndustry?.CountableFeatures">
                <ms-feature-element
                    [feature]="feature"
                    [featureDataSheet]="getFeatureDataSheetDetail(feature.Fragment)"
                    [industry]="this.currentIndustry"
                    [editionCode]="this.editionSelected"
                    (onfeatureClick)="onfeatureclick($event)"
                >
                </ms-feature-element>
            </div>
        </mat-expansion-panel>
    </div>

    <div *ngIf="this.currentIndustry?.PptFeatures?.length > 0">
        <mat-expansion-panel class="functionalityGroupContainer2">
            <mat-expansion-panel-header>
                <mat-panel-title><span translate>INDUSTRY_CONFIGURATOR.OTHERSERVICES</span></mat-panel-title>
            </mat-expansion-panel-header>
            <div class="contentGlobalFragment" *ngFor="let feature of this.currentIndustry?.PptFeatures">
                <ms-feature-element
                    [feature]="feature"
                    [featureDataSheet]="getFeatureDataSheetDetail(feature.Fragment)"
                    [industry]="this.currentIndustry"
                    [editionCode]="this.selectedEdition"
                    (onfeatureClick)="
                        onfeatureclick($event, this.editionSelected, feature, this.currIndustryPurchInfo, this.currentIndustry)
                    "
                >
                </ms-feature-element>
            </div>
        </mat-expansion-panel>
    </div>
</mat-accordion>
